import React, { useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { Close, ListAlt } from '@mui/icons-material';
import CaseApi from '../../../../Service/Case.api';

interface CommissionModalProps {
  open: boolean;
  onClose: () => void;
}

const CommissionModal: React.FC<CommissionModalProps> = ({ open, onClose }) => {
  const [orderTypes, setOrderTypes] = useState<any[]>([]);

  useEffect(() => {
    if (open) {
      loadOrderTypes();
    }
  }, [open]);

  const loadOrderTypes = async () => {
    try {
      const res: any = await CaseApi.fetchOrderTypes();
      console.log("Order types", res);
      if (res) {
        setOrderTypes(Array.isArray(res) ? res : res.data || []);
      }
    } catch (err) {
      console.error("Error fetching order types for commission modal", err);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ bgcolor: '#f8f9fa', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center', fontWeight: 600 }}>
          <ListAlt sx={{ mr: 1 }} /> Schedule A: Commission & Platform Charges
        </Typography>
        <IconButton onClick={onClose}>
          <Close />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          The following retention rates apply to services rendered through NoLegalPaisa.com:
        </Typography>
        <TableContainer component={Paper} variant="outlined">
          <Table>
            <TableHead sx={{ bgcolor: '#212529' }}>
              <TableRow>
                <TableCell sx={{ color: '#fff', fontWeight: 600 }}>Service Category</TableCell>
                <TableCell sx={{ color: '#fff', fontWeight: 600 }}>Platform Charge (%)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orderTypes.filter(ot => ot.platformChargePercent > 0).map((ot) => (
                <TableRow key={ot.id}>
                  <TableCell>{ot.name}</TableCell>
                  <TableCell>{ot.platformChargePercent}%</TableCell>
                </TableRow>
              ))}
              {orderTypes.filter(ot => ot.platformChargePercent > 0).length === 0 && (
                <TableRow>
                  <TableCell colSpan={2} align="center">No platform charges available.</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
};

export default CommissionModal;
